export default __webpack_public_path__ + "static/media/intro-pic.995a93ab.jpg";